<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('orders.warehouseDeliveredOrdersTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            send_to_pending_shipment: 'send_to_pending_shipment',
            generate_qr_code: 'purchase_generate_qrcode',
            add_permission: 'add_new_order',
            new_shiponly: 'new_shiponly',
          }"
          :addNewOrderButton="false"
          :addNewShiponlyButton="true"
          :openAddNewShiponlyModal="openAddNewShiponlyModal"
          :openAddNewOrderModal="openAddNewOrderModal"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addSendToIntShipmentButton="true"
          :addSendAllToIntShipmentButton="true"
          :addQrCodeGenerateButton="true"
          :openGenerateQrCodeModal="openGenerateQrCodeModal"
          :openSendToIntShipmentModal="openSendToIntShipmentModal"
          :sendAllToIntShipment="sendAllToIntShipment"
          :tableData="tableData"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :defaultHideCol="defaultHideCol"
          :storageKey="'cols_warehouseDeliveredOrder_v2'"
          :resultsVersion="resultsVersion"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :warehouseFilterItems="warehouseFilterList"
          :warehouseFilterChange="handleWarehouseFilter"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'background-color: #FFF9C4' : '' "
                class="table-tr"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                      r.product_name,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <!-- QR -->
                <td><i v-if="r.qrcode" class="fa fa-qrcode" aria-hidden="true"></i> {{ r.qrcode || '—' }}</td>
                <!-- Item Code -->
                <td>
                  <span v-if="r.qrcode == null || r.qrcode == ''">{{ r.theOrderID }}</span>
                  <span v-else><i class="fa fa-qrcode" aria-hidden="true"></i> {{ r.theOrderID }}</span>
                  <span v-if="r.track_number" style="display:block; font-size:11px; color:#555;">{{ r.track_number }}</span>
                </td>
                <!-- Invoice No. -->
                <td>{{ r.last_order_invoice || '—' }}</td>
                <!-- Customer ID -->
                <td>{{ r.customer_id_fk || '—' }}</td>
                <!-- Phone Number -->
                <td>{{ r.phone_number || '—' }}</td>
                <!-- Customer -->
                <td class="ws-nowrap">
                  <img v-if="r.profile_image" :src="r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <customer-device-icon :orderSource="r.order_source" />
                  <span class="customer-name-stack">
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <span v-if="r.phone_number" class="customer-phone-line">{{ r.phone_number }}</span>
                    <span v-if="r.phone_number_2" class="customer-phone-line">{{ r.phone_number_2 }}</span>
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <!-- Item Name -->
                <td>{{ r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : '—' }}</td>
                <!-- Brand -->
                <td>{{ r.brand }}</td>
                <!-- URL -->
                <td style="text-align:center;">
                  <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                    <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                  </a>
                  <span v-else style="color:#bbb;">—</span>
                </td>
                <!-- Image -->
                <td style="text-align:center">
                  <img v-if="r.image" :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`" width="130" style="border-radius:4px; cursor:pointer;" @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"/>
                  <span v-else style="color:#bbb; font-size:11px;">—</span>
                </td>
                <!-- Date & Time -->
                <td style="min-width: 130px" class="hover-container">
                  <view-order-dates :orderData="r" />
                </td>
                <!-- Status -->
                <td>
                  <span style="display:inline-block; padding:2px 8px; border-radius:12px; font-size:12px; font-weight:500; background:#831C91; color:#FFFFFF;">{{ $_status_label(r.status) }}</span>
                </td>
                <!-- Warehouse -->
                <td>{{ r.country || '—' }}</td>
                <!-- Type -->
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '—' }}</td>
                <!-- Summary (Price/Shipping/Total/Size) -->
                <td class="combined-cell-td">
                  <div class="combined-cell">
                    <div><span class="combined-cell-label">{{ $t('columns.price') }}:</span> {{ r.item_price ? '$' + r.item_price : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.shipping') }}:</span> {{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.total') }}:</span> {{ r.total_amount ? '$' + r.total_amount : '—' }}</div>
                    <div class="combined-cell-divider"></div>
                    <div><span class="combined-cell-label">{{ $t('columns.qty') }}:</span> {{ r.quantity || '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.size') }}:</span> {{ r.size || '—' }}</div>
                  </div>
                </td>
                <!-- Shiponly -->
                <td>
                  <span v-if="r.is_ship_only == 1" class="ship-only-label">{{ $t('columns.shipOnly') }}</span>
                  <span v-else style="color:#bbb;">—</span>
                </td>
                <!-- Purchase Note -->
                <td>{{ r.purchase_note || '—' }}</td>
                <!-- Bank (hidden) -->
                <!-- <td>{{ r.bank_name || '—' }}</td> -->
                <!-- Price -->
                <td>{{ r.item_price ? '$' + r.item_price : '—' }}</td>
                <!-- Shipping -->
                <td>{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</td>
                <!-- Total -->
                <td>{{ r.total_amount ? '$' + r.total_amount : '—' }}</td>
                <!-- Size -->
                <td>{{ r.size || '—' }}</td>
                <!-- Qty -->
                <td>{{ r.quantity || '—' }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  class="rtl-pl-10 rtl-pr-5"
                >
                  <a
                    style="color:#01579B"
                    :tooltip="$t('orders.viewDetails')"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('send_to_pending_shipment')"
                  class="rtl-pl-0 rtl-pr-10"
                >
                  <a
                    style="color:#4FC3F7"
                    :tooltip="$t('orders.pendingShipmentTooltip')"
                    @click="pendingShipmentOrder(r.order_id)"
                  >
                    <span class="pending-boat-icon">
                      <i class="material-icons boat-base">directions_boat</i>
                      <i class="material-icons boat-badge">schedule</i>
                    </span>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('return_warehouse_delivered_order_to_purchased_order')"
                  class="rtl-pl-0 rtl-pr-10"
                >
                  <a
                    style="color:#eb8545"
                    :tooltip="$t('orders.returnToPurchaseTooltip')"
                    @click="returnToPurchase(r.order_id)"
                  >
                    <i class="material-icons">settings_backup_restore</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('take_photo')"
                  class="rtl-pl-0 rtl-pr-10"
                >
                  <a
                    style="color:#666; font-size: 16px"
                    :tooltip="$t('orders.takePhotoTooltip')"
                    @click="openTakePhotoModal(r)"
                  >
                    <i class="fa fa-camera"></i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('add_order_case')"
                  class="px-2"
                >
                  <a
                    @click="openCreateOrderCaseModal(r)"
                    style="color: #555"
                    :tooltip="$t('orders.createCaseTooltip')"
                  >
                    <i
                      class="fa fa-folder-open"
                      style="font-size: 1.6rem"
                    />
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <div v-if="isMobile" class="moc-container">
            <div
              v-for="(r, index) in apiResults"
              :key="r.order_id"
              class="moc-card"
              :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'border-left: 3px solid #FBC02D;' : ''"
            >
              <div class="moc-header">
                <input
                  :id="'cb' + index"
                  type="checkbox"
                  :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID, r.is_ship_only, r.product_name]"
                  v-model="qrCodeValues"
                />
                <span class="moc-item-code">
                  <i v-if="r.qrcode" class="fa fa-qrcode" aria-hidden="true"></i> {{ r.theOrderID }}
                  <span v-if="r.track_number" style="font-size:0.8rem; color:#555" class="rtl-ml-6">| {{ r.track_number }}</span>
                </span>
                <span class="moc-status-badge" style="background:#831C91; color:#FFFFFF;">{{ $_status_label(r.status) }}</span>
              </div>
              <div class="moc-body">
                <!-- QR -->
                <div class="moc-row" v-if="r.qrcode">
                  <span class="moc-label">{{ $t('columns.qr') }}</span>
                  <span class="moc-value"><i class="fa fa-qrcode" aria-hidden="true"></i> {{ r.qrcode }}</span>
                </div>
                <!-- Invoice # | Customer ID -->
                <div class="moc-row--2col">
                  <div><span class="moc-label">{{ $t('columns.invoiceNo') }}</span><span class="moc-value">{{ r.last_order_invoice || '—' }}</span></div>
                  <div><span class="moc-label">{{ $t('columns.customerId') }}</span><span class="moc-value">{{ r.customer_id_fk || '—' }}</span></div>
                </div>
                <!-- Phone Number -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.phone') }}</span>
                  <span class="moc-value">{{ r.phone_number || '—' }}</span>
                </div>
                <!-- User -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('common.user') }}</span>
                  <span class="moc-value"><view-order-users :orderData="r" /></span>
                </div>

                <!-- Customer -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.customer') }}</span>
                  <span class="moc-value">
                    <customer-device-icon :orderSource="r.order_source" />
                    <img v-if="r.profile_image" :src="r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break:break-word; white-space:pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                  </span>
                </div>

                <!-- Item Name -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.itemName') }}</span>
                  <span class="moc-value">{{ r.product_name ? r.product_name.substr(0, 60) + (r.product_name.length > 60 ? '...' : '') : '—' }}</span>
                </div>

                <!-- Brand -->
                <div class="moc-row" v-if="r.brand">
                  <span class="moc-label">{{ $t('columns.brand') }}</span>
                  <span class="moc-value">{{ r.brand }}</span>
                </div>

                <!-- URL -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.url') }}</span>
                  <span class="moc-value">
                    <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                      <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                    </a>
                    <span v-else style="color:#bbb;">—</span>
                  </span>
                </div>

                <!-- Image -->
                <div class="moc-row" v-if="r.image">
                  <span class="moc-label">{{ $t('columns.image') }}</span>
                  <span class="moc-value">
                    <img
                      :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                      style="width:80px; height:80px; object-fit:cover; border-radius:4px; cursor:pointer;"
                      @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                    />
                  </span>
                </div>

                <!-- Warehouse -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('columns.warehouse') }}</span>
                  <span class="moc-value">{{ r.country || '—' }}</span>
                </div>
                <!-- Type -->
                <div class="moc-row" v-if="r.transportation_type_obj">
                  <span class="moc-label">{{ $t('columns.type') }}</span>
                  <span class="moc-value">{{ r.transportation_type_obj.name.replace('Transportation', '') }}</span>
                </div>

                <!-- Price | Shipping | Total -->
                <div class="moc-row--3col">
                  <div>
                    <span class="moc-label">{{ $t('columns.price') }}</span>
                    <span class="moc-value">{{ r.item_price ? '$' + r.item_price : '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.shipping') }}</span>
                    <span class="moc-value">{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</span>
                  </div>
                  <div>
                    <span class="moc-label">{{ $t('columns.total') }}</span>
                    <span class="moc-value">{{ r.total_amount ? '$' + r.total_amount : '—' }}</span>
                  </div>
                </div>

                <!-- Size -->
                <div class="moc-row" v-if="r.size">
                  <span class="moc-label">{{ $t('columns.size') }}</span>
                  <span class="moc-value">{{ r.size }}</span>
                </div>

                <!-- Shiponly -->
                <div class="moc-row" v-if="r.is_ship_only == 1">
                  <span class="moc-label">{{ $t('columns.shipOnly') }}</span>
                  <span class="moc-value"><span class="ship-only-label">{{ $t('columns.shipOnly') }}</span></span>
                </div>

                <!-- Purchase Note -->
                <div class="moc-row" v-if="r.purchase_note">
                  <span class="moc-label">{{ $t('columns.purchaseNote') }}</span>
                  <span class="moc-value">{{ r.purchase_note }}</span>
                </div>

                <!-- Date -->
                <div class="moc-row">
                  <span class="moc-label">{{ $t('common.date') }}</span>
                  <span class="moc-value"><view-order-dates :orderData="r" /></span>
                </div>

                <!-- Bank (hidden) -->
                <!-- <div class="moc-row" v-if="r.bank_name">
                  <span class="moc-label">{{ $t('columns.bank') }}</span>
                  <span class="moc-value">{{ r.bank_name }}</span>
                </div> -->
              </div>

              <!-- Card actions -->
              <div class="moc-actions">
                <a
                  v-if="$_has_perm('view_order_detail')"
                  style="color: #01579b" class="rtl-pr-3"
                  :tooltip="$t('orders.viewDetails')"
                  @click="initDetail('modal_showApp', r.order_id)"
                >
                  <i class="material-icons">aspect_ratio</i>
                </a>
                <a
                  v-if="$_has_perm('send_to_pending_shipment')"
                  style="color: #4FC3F7" class="rtl-pr-3"
                  :tooltip="$t('orders.pendingShipmentTooltip')"
                  @click="pendingShipmentOrder(r.order_id)"
                >
                  <span class="pending-boat-icon">
                    <i class="material-icons boat-base">directions_boat</i>
                    <i class="material-icons boat-badge">schedule</i>
                  </span>
                </a>
                <a
                  v-if="$_has_perm('return_warehouse_delivered_order_to_purchased_order')"
                  @click="returnToPurchase(r.order_id)"
                  style="color: #eb8545" class="rtl-pr-3"
                  :tooltip="$t('orders.returnToPurchaseTooltip')"
                >
                  <i class="material-icons">settings_backup_restore</i>
                </a>
                <a
                  v-if="$_has_perm('take_photo')"
                  @click="openTakePhotoModal(r)"
                  style="color: #666; font-size: 16px" class="rtl-pr-3"
                  :tooltip="$t('orders.takePhotoTooltip')"
                >
                  <i class="fa fa-camera"></i>
                </a>
              </div>
            </div>
            <v-alert type="error" :value="alertValue"> {{ $t('common.noResultsFound') }} </v-alert>
          </div>

          <!-- Lightbox dialog -->
          <v-dialog v-model="lightboxOpen" max-width="600px">
            <v-card>
              <v-card-text style="padding:8px; background:#000; text-align:center;">
                <img v-if="lightboxImage" :src="lightboxImage" style="max-width:100%; max-height:80vh;" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="lightboxOpen = false">{{ $t('common.close') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <send-to-int-shipment
            :closeSendToIntShipmentModal="closeSendToIntShipmentModal"
            :sendToIntShipmentModal="sendToIntShipmentModal"
            :sendToIntShipmentData="sendToIntShipmentData"
            :sendToIntShipment="sendToIntShipment"
          >
          </send-to-int-shipment>

          <take-photo
            :takePhotoModal="takePhotoModal"
            :orderData="orderData"
            @close="takePhotoModal = false"
          />

          <add-new-order
            :addNewOrderModal="addNewOrderModal"
            :warehouses="warehouses"
            :closeAddNewOrderModal="closeAddNewOrderModal"
            :checkAlert="checkAlert"
            :checkURL="checkURL"
            :makeNewOrder="makeNewOrder"
            :makeOrderData="makeOrderData"
            :customers="customers"
            :loading="loading"
          >
          </add-new-order>

          <add-new-shiponly
            :addNewShiponlyModal="addNewShiponlyModal"
            :warehouses="warehouses"
            :closeAddNewShiponlyModal="closeAddNewShiponlyModal"
            :checkAlert="checkAlert"
            :checkURL="checkURL"
            :makeNewOrder="makeNewOrder"
            :makeOrderData="makeOrderData"
            :customers="customers"
            :loading="loading"
          >
          </add-new-shiponly>

          <create-qr-code
            :openGenerateQrCodeModal="openGenerateQrCodeModal"
            :generateQrCodeModal="generateQrCodeModal"
            :closeGenerateQrCodeModal="closeGenerateQrCodeModal"
            :qrCodeValues="qrCodeValues"
            :generateQrCode="generateQrCode"
            :getResults="getResults"
          ></create-qr-code>

          <add-edit-order-case
            :addEditOrderCaseModal="addEditOrderCaseModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditOrderCaseModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import sendToIntShipment from './sendToIntShipment.vue'
import axios from 'axios'
import swal from 'sweetalert'
import takePhoto from './takePhoto.vue'
import createQrCode from './createQrCode.vue'
import addNewOrder from './addNewOrder.vue'
import addNewShiponly from './addNewShiponly.vue'
import addEditOrderCase from './orderCase/addEditOrderCase.vue'
import statusHelpers from '../mixins/statusHelpers'

export default {
  mixins: [statusHelpers],
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'send-to-int-shipment': sendToIntShipment,
    'create-qr-code': createQrCode,
    takePhoto,
    'add-new-order': addNewOrder,
    'add-new-shiponly': addNewShiponly,
    addEditOrderCase
  },
  mounted() {
    this.$_fetch_statuses()
    this.perPageFix()
    this.getCustomer()
    this.getWarehouses()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      { label: this.$t('common.user'), text: this.$t('common.user'), value: '2', sortable: false, searchable: false, name: 'user' },
      { label: this.$t('columns.qr'), text: this.$t('columns.qr'), value: '3', sortable: true, searchable: true, name: 'qrcode' },
      // Track Number is displayed inline under Item Code (not a separate column)
      { label: this.$t('columns.itemCode'), text: this.$t('columns.itemCode'), value: '4', sortable: true, searchable: true, name: 'theOrderID' },
      { label: this.$t('columns.invoiceNo'), text: this.$t('columns.invoiceNo'), value: '5', sortable: true, searchable: false, name: 'last_order_invoice' },
      { label: this.$t('columns.customerId'), text: this.$t('columns.customerId'), value: '6', sortable: true, searchable: true, name: 'customer_id_fk' },
      { label: this.$t('columns.phoneNumber'), text: this.$t('columns.phoneNumber'), value: '7', sortable: true, searchable: true, name: 'phone_number' },
      { label: this.$t('columns.customer'), text: this.$t('columns.customer'), value: '8', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.itemName'), text: this.$t('columns.itemName'), value: '9', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.brand'), text: this.$t('columns.brand'), value: '10', sortable: true, searchable: true, name: 'brand' },
      { label: this.$t('columns.url'), text: this.$t('columns.url'), value: '11', sortable: false, searchable: false, name: 'product_url' },
      { label: this.$t('columns.image'), text: this.$t('columns.image'), value: '12', sortable: false, searchable: false, name: 'image' },
      { label: this.$t('columns.dateTime'), text: this.$t('columns.dateTime'), value: '13', sortable: true, searchable: false, name: 'warehouse_deliver_date' },
      { label: this.$t('columns.status'), text: this.$t('columns.status'), value: '14', sortable: true, searchable: true, name: 'status' },
      { label: this.$t('columns.warehouse'), text: this.$t('columns.warehouse'), value: '15', sortable: true, searchable: true, name: 'country' },
      { label: this.$t('columns.type'), text: this.$t('columns.type'), value: '16', sortable: true, searchable: true, name: 'transportation_type_obj' },
      { label: this.$t('columns.summary'), text: this.$t('columns.summary'), value: '17', sortable: false, searchable: false, name: 'price_all' },
      { label: this.$t('columns.shipOnly'), text: this.$t('columns.shipOnly'), value: '18', sortable: true, searchable: true, name: 'is_ship_only' },
      { label: this.$t('columns.purchaseNote'), text: this.$t('columns.purchaseNote'), value: '19', sortable: true, searchable: true, name: 'purchase_note' },
      { label: this.$t('columns.price'), text: this.$t('columns.price'), value: '20', sortable: true, searchable: true, name: 'item_price' },
      { label: this.$t('columns.shipping'), text: this.$t('columns.shipping'), value: '21', sortable: true, searchable: true, name: 'internal_shipping_handling' },
      { label: this.$t('columns.total'), text: this.$t('columns.total'), value: '22', sortable: true, searchable: true, name: 'total_amount' },
      { label: this.$t('columns.size'), text: this.$t('columns.size'), value: '23', sortable: true, searchable: true, name: 'size' },
      { label: this.$t('columns.qty'), text: this.$t('columns.qty'), value: '24', sortable: true, searchable: true, name: 'quantity' }
      // { label: 'Bank', text: 'Bank', value: '25', sortable: true, searchable: true, name: 'bank_name' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      defaultHideCol: ['7', '19', '20', '21', '22', '23', '24'],
      url: 'api/warehouse_delivered_order',
      intPendingShipmentUrl: 'api/pending_shipmenting',
      // intShipmentUrl: 'api/int_shipmenting',
      initMultiplePendingShipmentUrl: 'api/pending_shipmenting_multiple_order',
      // initMultipleShipmentUrl: 'api/pending_shipmenting_multiple_order',
      intPendingShipmentByQrCodeUrl: 'api/pending_shipmenting_by_qrcode',
      // intShipmentByQrCodeUrl: 'api/int_shipmenting_by_qrcode',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      sendToIntShipmentModal: false,
      generateQrCodeModal: false,
      qrCodeValues: [],
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      resultsVersion: 0,
      btnsave: true,
      queryParameter: true,
      orderData: {},
      takePhotoModal: false,
      addNewOrderModal: false,
      addNewShiponlyModal: false,
      formData: {},
      isUpdate: false,
      addEditOrderCaseModal: false,
      warehouses: [],
      customers: [],
      checkURL: false,
      makeOrderData: {
        customer_id_fk: '',
        warehouse_id_fk: '',
        transportation_type: null,
        product_name: '',
        product_url: '',
        quantity: '',
        delivery_type: '',
        item_weight: '',
        volume: '',
        track_number: '',
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        internal_shipping_handling: 0,
        is_from_warehouse: 1,
        is_ship_only: 1
      },
      sendToIntShipmentData: {
        order_id: ''
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      warehouseFilterList: [],
      lightboxImage: null,
      lightboxOpen: false,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: '',
        warehouse_id_fk: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    checkAll() {
      this.qrCodeValues = this.apiResults.map(r => [r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID, r.is_ship_only, r.product_name])
    },

    unCheckAll() {
      this.qrCodeValues = []
    },

    openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      }
      this.isUpdate = false
      this.addEditOrderCaseModal = true
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types, currency: r.currency })
          })
          this.warehouseFilterList = this.warehouses
        })
    },

    handleWarehouseFilter(val) {
      this.tableData.warehouse_id_fk = Array.isArray(val) && val.length ? val.join(',') : ''
      this.url = 'api/warehouse_delivered_order'
      this.getResults()
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((c) => {
            const phone1 = c.phone_number || ''
            const phone2 = c.phone_number_2 || ''
            const phones = [phone1, phone2].filter(Boolean).join(' / ')
            this.customers.push({
              text: c.user_id + ' - ' + c.full_name + (phones ? ' - Tel: ' + phones : ''),
              value: c.user_id,
              full_name: c.full_name,
              phone_number: phone1,
              phone_number_2: phone2
            })
          })
        })
    },

    getItemType() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-item-type', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((c) => {
            this.itemTypes.push({
              text: c.type_name,
              value: c.type_name,
              shippingPrice: c.type_int_shipping_price
            })
          })
        })
    },

    clearNewOrderData() {
      this.makeOrderData.warehouse_id_fk = null
      this.makeOrderData.transportation_type = null
      this.makeOrderData.product_name = ''
      this.makeOrderData.product_url = ''
      this.makeOrderData.quantity = ''
      this.makeOrderData.item_weight = ''
      this.makeOrderData.volume = ''
      this.makeOrderData.track_number = ''
      this.makeOrderData.note = ''
      this.makeOrderData.coupon = ''
      this.makeOrderData.size = ''
      this.makeOrderData.type = ''
      this.makeOrderData.color = ''
      this.makeOrderData.c_o_d = ''
      this.makeOrderData.internal_shipping_handling = 0
      this.makeOrderData.is_from_warehouse = 1
      this.makeOrderData.is_ship_only = 1
      this.makeOrderData.customer_id_fk = null
      this.checkAlert = false
      this.checkURL = false
      this.loading = false
    },

    openAddNewOrderModal() {
      this.makeOrderData.warehouse_id_fk = this.warehouses[0].value
      this.addNewOrderModal = true
    },

    openAddNewShiponlyModal() {
      this.addNewShiponlyModal = true
    },

    closeAddNewOrderModal() {
      this.addNewOrderModal = false
      this.clearNewOrderData()
    },

    closeAddNewShiponlyModal() {
      this.addNewShiponlyModal = false
      this.clearNewOrderData()
    },

    makeNewOrder() {
      this.loading = true
      let token = localStorage.getItem('access_token')

      this.makeOrderData.delivery_type = 'office delivery'
      this.makeOrderData.status = 'warehouse_delivered_order'

      axios.post('api/orders', this.makeOrderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then((res) => {
        this.loading = false
        this.checkURL = false
        this.checkAlert = true
        setTimeout(() => {
          this.closeAddNewShiponlyModal()
          this.openTakePhotoModal(res.data.data)
        }, 500)
        this.getResults()
      }).catch((error) => {
        this.loading = false
        this.checkAlert = false
        if (error.response.data.message.product_url) {
          this.checkURL = true
        } else {
          this.checkURL = false
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        }
      })
    },

    openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: this.$t('orders.pleaseAtLeastSelectOneOrder'),
          icon: 'warning',
          dangerMode: true
        })
      } else {
        this.generateQrCodeModal = true
      }
    },

    closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false
      this.qrCodeValues = []
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    openTakePhotoModal(order) {
      this.orderData = order
      this.takePhotoModal = true
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/warehouse-export?' + arr)
    },

    getOrderID(orders) {
      this.orderID = []
      for (let i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id
      }
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action, affecting rows the user never intended
      // to touch in the current (filtered) view.
      this.qrCodeValues = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }
          this.resultsVersion++

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getOrderID(this.apiResults)
          if (theDatatable) { theDatatable.classList.remove('slide-table-out') }
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse_id_fk = ''
      this.getResults()
    },

    sendAllToIntShipment() {
      const ordersId = this.qrCodeValues.map(e => e[0])

      if (ordersId.length === 0) {
        return swal(this.$t('common.error'), this.$t('orders.pleaseSelectOrder'), 'error')
      }

      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(confirmed => {
        if (confirmed) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.initMultiplePendingShipmentUrl, { orders_id: ordersId }, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    openSendToIntShipmentModal() {
      this.sendToIntShipmentModal = true
    },

    closeSendToIntShipmentModal() {
      this.sendToIntShipmentModal = false
      this.sendToIntShipmentData.order_id = ''
      this.$validator.reset()
    },

    sendToIntShipment() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.intPendingShipmentByQrCodeUrl + '/' + this.sendToIntShipmentData.order_id, '', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.sendToIntShipmentData.order_id = ''
          this.getResults()
          swal({
            title: this.$t('common.done'),
            text: '',
            icon: 'success',
            timer: 500,
            buttons: false
          })
        })
        .catch(error => {
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    pendingShipmentOrder(id) {
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('orders.oncePendingShipmentedWarning'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.intPendingShipmentUrl + '/' + id, '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    returnToPurchase(id) {
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('orders.confirmReturnToPurchasedSection'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.returnToPurchaseUrl + id + '/return_to_purchase', '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    resetGetResults2() {
      this.resetGetResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
/* Mobile order cards: see assets/mobile-order-cards.css */

.customer-name-stack {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
}
.customer-phone-line {
  display: block;
  font-size: 14px;
  color: #666;
}
.combined-cell-td {
  vertical-align: middle;
}
.combined-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
.combined-cell-label {
  color: #888;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  /* overflow: hidden; */
  /* overflow-y: hidden; */
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
.pending-boat-icon {
  position: relative;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}
.pending-boat-icon .boat-base {
  font-size: 24px;
  line-height: 24px;
}
.pending-boat-icon .boat-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  font-size: 14px;
  background: #fff;
  color: #ff9800; /* pending color */
  border-radius: 50%;
  padding: 2px;
  box-shadow: 0 0 0 1px #ddd;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseDeliveredOrder.vue